const arabic = {
	// export default {
	lang: "Ar",
	back: "خلف",
	backDesc: "العودة إلى قائمة الدولة",
	tazkirahDesc: [
		`"تذكرة"`,
		`tazkirah-arab-2`,
		`tazkirah-arab-3`,
		`tazkirah-arab-4`,
		`tazkirah-arab-5`,
	],
	prayerList: {
		// imsak: "ImsakArab",
		fajr: "الفجر",
		syuruk: "الشروق",
		dhuhr: "الظهر",
		asr: "العصر",
		maghrib: "المغرب",
		isha: "العشاء",
	},
	close: "أغلق",
	settings: "الإعدادات",
	locationSelector: "اختر موقعا",
	prayerTimeEstimate: "غادر حتى",
	changeLang: "غير اللغة",
	changeSettings: "تغيير الاعدادات",
	setDarkMode: "حدد الوضع المظلم",
	setMinimal: "حدد الوضع الأدنى",
	// setLocation: "اختر موقعا",
	credit: "AA",
	subcredit: "صنع في ماليزيا",
	subcredit_extra: "شكرا لكم على خط المواجهة #covid19Malaysia",
	enableNotification: "تفعيل الإشعارات",
	currentPrayerTime: "وقت الصلاة الحالي",
};

export default arabic;